import { ROUTES } from '@/routes/paths';

const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null;
};

const APP_SELLER_INFO_KEYS = ['AppSellerInfo', 'appSellerInfo'] as const;
const SUBSCRIPTION_KEYS = [
  'IsAnySubscribed',
  'isAnySubscribed',
  'IsSubcribed',
  'isSubcribed',
] as const;
const MEMBERSHIP_STATE_KEYS = ['MembershipState', 'membershipState'] as const;
const PAID_MEMBERSHIP_STATES = new Set([
  'WEB_SUBSCRIBED',
  'APP_SUBSCRIBED',
  'APP_SUBSCRIBED_WEB_CONVERSION_PENDING',
]);

const PAID_MEMBERSHIP_PATH_PREFIXES = [
  ROUTES.dashboard,
  ROUTES.statistics,
  ROUTES.orders,
  ROUTES.monitoring,
  ROUTES.productOptimization,
  ROUTES.market,
  ROUTES.PcMarketConnectinoComplete,
  ROUTES.updateInfo,
  ROUTES.productShipment,
  ROUTES.productShipmentGuide,
  ROUTES.inquiryList,
  ROUTES.inquiryDetail,
  ROUTES.inquiryGuide,
  ROUTES.templatesInquiryList,
  ROUTES.templatesInquiryDetail,
  ROUTES.discoverMain,
  ROUTES.aiChatBot,
  ROUTES.statisticsMain,
  ROUTES.makeName,
  ROUTES.changeName,
  ROUTES.diagnoseProduct,
].filter(Boolean);

export const hasPaidMembershipAccess = (serviceInfo: unknown) => {
  if (!isRecord(serviceInfo)) return false;

  const appSellerInfo = APP_SELLER_INFO_KEYS.map((key) => serviceInfo[key]).find(isRecord);
  if (!appSellerInfo) return hasPaidMembershipState(serviceInfo);

  if (hasPaidMembershipState(serviceInfo) || hasPaidMembershipState(appSellerInfo)) return true;

  return SUBSCRIPTION_KEYS.some((key) => appSellerInfo[key] === true);
};

const hasPaidMembershipState = (record: Record<string, unknown>) => {
  return MEMBERSHIP_STATE_KEYS.some((key) => {
    const membershipState = record[key];

    return typeof membershipState === 'string' && PAID_MEMBERSHIP_STATES.has(membershipState);
  });
};

export const isPaidMembershipRequiredPath = (pathWithSearch: string) => {
  const pathname = pathWithSearch.split('?')[0] ?? pathWithSearch;

  return PAID_MEMBERSHIP_PATH_PREFIXES.some((paidPath) => {
    if (pathname === paidPath) return true;

    return pathname.startsWith(`${paidPath}/`);
  });
};

export const getMembershipConversionPath = (pathname: string) => {
  return pathname.startsWith(`${ROUTES.mobileRoot}/`)
    ? ROUTES.mobileMembership
    : ROUTES.moreMembership;
};
